// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import {
  CreatePurchaseOrderRequest,
  PurchaseOrder,
  purchaseOrderSchema,
} from '@/purchase-order/api/types';
import { serializeDateForAPI } from '@/utilities/date-time';

/**
 * Type definition for the API response wrapper.
 */
interface ApiResponse {
  data: unknown;
  metadata: { requestId: string };
}

/**
 * Creates a new purchase order with the specified details.
 */
export async function createPurchaseOrder(
  request: CreatePurchaseOrderRequest
): Promise<PurchaseOrder> {
  const url = '/v1/purchase-order';
  const apiRequest = {
    ...request,
    promiseShipDate: serializeDateForAPI(request.promiseShipDate),
    promiseDeliveryDate: serializeDateForAPI(request.promiseDeliveryDate),
  };
  const response = await api.post<ApiResponse>(url, apiRequest);

  // Parse and validate the response with Zod
  return parseResponse(purchaseOrderSchema, response.data.data, {
    schemaName: 'CreatePurchaseOrder',
    endpoint: url,
  });
}
